import { gql as t } from "@apollo/client";
const o = t`
  mutation SendForgotPasswordOTP(
    $email: String!
    $geetestInput: ValidateGeetestInput!
  ) {
    sendForgotPasswordOTP(input: { email: $email, geetestInput: $geetestInput })
  }
`;
export {
  o as default
};
//# sourceMappingURL=sendForgotPasswordOTP.js.map
